(() => {
const erTranslate = (text, values) => typeof window !== 'undefined' && window.ERStorefrontI18n ? window.ERStorefrontI18n.translate(text, values) : text;
document.addEventListener('DOMContentLoaded', () => {
  const setProductFraming = (image, data) => {
    const frame = image?.closest('[data-er-product-frame]');
    if (!frame) return;
    frame.dataset.erFrame = data || '';
    if (!data) return;
    const values = data.split('|').map(Number);
    if (values.length !== 5 || values.some(value => !Number.isFinite(value))) return;
    const [aspect, imageWidth, centerX, centerY, cardWidth] = values;
    const card = frame.closest('.product-card-image');
    const cardAspect = card && card.clientHeight > 0 ? card.clientWidth / card.clientHeight : 0;
    const fitWidth = cardAspect > 0 ? imageWidth * Math.min(1, aspect / cardAspect) : imageWidth;
    frame.style.setProperty('--er-frame-aspect', String(aspect));
    frame.style.setProperty('--er-frame-width', fitWidth + '%');
    frame.style.setProperty('--er-frame-card-width', (cardAspect > 0 ? fitWidth : cardWidth) + '%');
    frame.style.setProperty('--er-frame-x', -centerX + '%');
    frame.style.setProperty('--er-frame-y', -centerY + '%');
  };
  document.querySelectorAll('[data-er-product-frame]').forEach(frame => setProductFraming(frame.querySelector('img'), frame.dataset.erFrame));
  window.addEventListener('resize', () => {
    document.querySelectorAll('.product-card-image [data-er-product-frame]').forEach(frame => setProductFraming(frame.querySelector('img'), frame.dataset.erFrame));
  }, { passive: true });

  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.getElementById('MobileMenu');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? erTranslate('Close menu') : erTranslate('Open menu'));
      menu.hidden = !open;
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }
  document.querySelectorAll('[data-sort-select]').forEach(select => {
    select.addEventListener('change', () => select.form.submit());
  });
  document.querySelectorAll('.collection-reference [data-card-swatches]').forEach(group => {
    const more = group.querySelector('[data-card-swatches-more]');
    if (!more) return;
    const swatches = Array.from(group.querySelectorAll('[data-card-swatch]'));
    const updateSwatches = expanded => {
      const visible = swatches.slice(0, 3);
      const selected = swatches.find(swatch => swatch.getAttribute('aria-current') === 'true');
      if (selected && !visible.includes(selected)) visible[2] = selected;
      swatches.forEach(swatch => { swatch.hidden = !expanded && !visible.includes(swatch); });
      const remaining = swatches.length - visible.length;
      more.hidden = remaining <= 0;
      more.setAttribute('aria-expanded', String(expanded));
      more.setAttribute('aria-label', expanded ? erTranslate('Show fewer colors') : erTranslate('Show {{count}} more colors', {count:remaining}));
      more.textContent = expanded ? '−' : `+${remaining}`;
    };
    updateSwatches(false);
    more.addEventListener('click', () => updateSwatches(more.getAttribute('aria-expanded') !== 'true'));
  });
  document.querySelectorAll('.collection-reference [data-card-swatch]').forEach(swatch => {
    swatch.addEventListener('click', event => {
      const card = swatch.closest('.product-card');
      const image = card?.querySelector('[data-card-image-link] img');
      if (!card || !image || !swatch.dataset.cardImage) return;
      event.preventDefault();
      image.fetchPriority = 'auto';
      const maxImageWidth = Number(swatch.dataset.cardImageWidth);
      if (swatch.dataset.cardImageSrcset) {
        image.sizes = image.sizes || '100vw';
        image.srcset = swatch.dataset.cardImageSrcset;
      } else if (maxImageWidth > 0) {
        const imageWidths = [240, 360, 480, 600, 800, 1000, 1200].filter(width => width < maxImageWidth).concat(maxImageWidth);
        const imageUrl = new URL(swatch.dataset.cardImage, window.location.href);
        image.sizes = image.sizes || '100vw';
        image.srcset = imageWidths.map(width => {
          const candidate = new URL(imageUrl);
          candidate.searchParams.set('width', width);
          return `${candidate.href} ${width}w`;
        }).join(', ');
      } else {
        image.removeAttribute('srcset');
      }
      image.src = swatch.dataset.cardImage;
      setProductFraming(image, swatch.dataset.cardImageFrame);
      image.alt = `${swatch.dataset.cardColor} — ${card.querySelector('[data-card-title-link]')?.textContent || ''}`;
      card.querySelectorAll('[data-card-swatch]').forEach(item => item.removeAttribute('aria-current'));
      swatch.setAttribute('aria-current', 'true');
      card.querySelectorAll('[data-card-image-link], [data-card-title-link]').forEach(link => { link.href = swatch.href; });
      const colorName = card.querySelector('[data-card-color-name]');
      if (colorName) colorName.textContent = swatch.dataset.cardColor;
      const price = card.querySelector('.product-price[data-card-price]');
      if (price && swatch.dataset.cardPrice) {
        const currentPrice = price.querySelector('[data-card-current-price]');
        const comparePrice = price.querySelector('[data-card-compare-price]');
        if (currentPrice && comparePrice) {
          currentPrice.textContent = swatch.dataset.cardPrice;
          const compareValue = swatch.dataset.cardComparePrice || '';
          comparePrice.textContent = compareValue;
          comparePrice.hidden = !compareValue;
          const compareLabel = price.querySelector('[data-card-compare-label]');
          if (compareLabel) compareLabel.hidden = !compareValue;
          price.classList.toggle('is-on-sale', Boolean(compareValue));
        } else {
          price.textContent = swatch.dataset.cardPrice;
        }
      }
    });
  });
  document.querySelectorAll('.collection-reference-filter-menu').forEach(menu => {
    document.addEventListener('click', event => {
      if (menu.open && !menu.contains(event.target)) menu.open = false;
    });
    menu.addEventListener('keydown', event => {
      if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary')?.focus(); }
    });
  });
  document.querySelectorAll('[data-snow-motion-toggle]').forEach(button => {
    button.addEventListener('click', () => {
      const container = button.closest('[data-snow-motion]');
      const video = container?.querySelector('video');
      if (!video) return;
      const paused = !video.paused;
      if (paused) video.pause(); else video.play();
      container.classList.toggle('is-paused', paused);
      button.textContent = paused ? '▶' : 'Ⅱ';
      button.setAttribute('aria-label', paused ? erTranslate('Play background motion') : erTranslate('Pause background motion'));
    });
  });
  document.querySelectorAll('.quantity-control').forEach(control => {
    const input = control.querySelector('input');
    control.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { input.value = String(Math.max(1, Number(input.value || 1) - 1)); });
    control.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { input.value = String(Math.max(1, Number(input.value || 1) + 1)); });
  });
  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const images = [...gallery.querySelectorAll('[data-gallery-image]')];
    const snowSourceData = gallery.querySelector('[data-snow-refined-sources]');
    const snowSources = snowSourceData ? JSON.parse(snowSourceData.textContent || '{}') : {};
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const count = gallery.querySelector('[data-gallery-count]');
    const previousButton = gallery.querySelector('[data-gallery-prev]');
    const nextButton = gallery.querySelector('[data-gallery-next]');
    if (images.length < 2) return;
    const rail = gallery.querySelector('.product-gallery-thumbs');
    const stage = gallery.querySelector('.product-gallery-stage');
    const desktopGallery = window.matchMedia('(min-width: 761px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const revealThumb = (behavior = 'smooth') => {
      if (!desktopGallery.matches || !rail || !thumbs[current]) return;
      const viewport = rail.getBoundingClientRect();
      const thumb = thumbs[current].getBoundingClientRect();
      if (thumb.top < viewport.top || thumb.bottom > viewport.bottom) {
        rail.scrollBy({ top: thumb.top - viewport.top - (viewport.height - thumb.height) / 2,
          behavior: reducedMotion.matches ? 'instant' : behavior });
      }
    };
    if (stage && rail && 'ResizeObserver' in window) {
      new ResizeObserver(() => {
        if (!desktopGallery.matches) return;
        gallery.style.setProperty('--gallery-stage-height', `${stage.getBoundingClientRect().height}px`);
        requestAnimationFrame(() => revealThumb('instant'));
      }).observe(stage);
    }
    const primaryImage = images[0].querySelector('img');
    const primaryThumb = thumbs[0]?.querySelector('img');
    const originalPrimary = primaryImage && { src: primaryImage.src, srcset: primaryImage.getAttribute('srcset'), frame: primaryImage.closest('[data-er-product-frame]')?.dataset.erFrame || '' };
    const originalThumb = primaryThumb && { src: primaryThumb.src, srcset: primaryThumb.getAttribute('srcset') };
    const initialIndex = Number(gallery.dataset.initialGalleryIndex || 0);
    let current = Number.isInteger(initialIndex) && initialIndex >= 0 && initialIndex < images.length ? initialIndex : 0;
    const restorePrimary = () => {
      if (gallery.hasAttribute('data-snow-color-gallery')) return;
      if (primaryImage && originalPrimary) {
        primaryImage.src = originalPrimary.src;
        setProductFraming(primaryImage, originalPrimary.frame);
        if (originalPrimary.srcset) primaryImage.setAttribute('srcset', originalPrimary.srcset);
      }
      if (primaryThumb && originalThumb) {
        primaryThumb.src = originalThumb.src;
        if (originalThumb.srcset) primaryThumb.setAttribute('srcset', originalThumb.srcset);
      }
    };
    const show = (index, preserveVariant = false) => {
      const previous = current;
      current = (index + images.length) % images.length;
      if (current === 0 && !preserveVariant) restorePrimary();
      if (!preserveVariant && !gallery.hasAttribute('data-snow-color-gallery')) {
        const select = gallery.closest('.product-layout')?.querySelector('[data-variant-select]');
        const selected = select?.selectedOptions[0];
        const otherOptions = [...(select?.closest('.product-form')?.querySelectorAll('[data-option-position]') || [])]
          .filter(group => !/^colou?r$/i.test(group.dataset.optionName || ''));
        const matches = select ? [...select.options].filter(option =>
          option.dataset.imageId === images[current].dataset.mediaId && otherOptions.every(group =>
            option.dataset[`option${group.dataset.optionPosition}`] === selected?.dataset[`option${group.dataset.optionPosition}`]
          )
        ) : [];
        const variant = matches.find(option => option.value === select.value) || matches.find(option => !option.disabled) || matches[0];
        if (variant && variant.value !== select.value) {
          select.value = variant.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      images.forEach((item, position) => { item.hidden = position !== current; });
      thumbs.forEach((item, position) => { item.setAttribute('aria-pressed', String(position === current)); });
      revealThumb();
      if (desktopGallery.matches && !reducedMotion.matches && previous !== current) {
        images[current].getAnimations().forEach(animation => animation.cancel());
        images[current].animate([
          { opacity: 0.35, transform: `translateX(${index > previous ? 18 : -18}px)` },
          { opacity: 1, transform: 'translateX(0)' }
        ], { duration: 180, easing: 'ease-out' });
      }
      if (count) count.textContent = `${current + 1} / ${images.length}`;
      if (gallery.closest('.pdp-snow')) {
        if (previousButton) previousButton.disabled = current === 0;
        if (nextButton) nextButton.disabled = current === images.length - 1;
      }
    };
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
    previousButton?.addEventListener('click', () => show(current - 1));
    nextButton?.addEventListener('click', () => show(current + 1));
    rail?.addEventListener('keydown', event => {
      if (!desktopGallery.matches) return;
      const keys = { ArrowUp: current - 1, ArrowDown: current + 1, Home: 0, End: images.length - 1 };
      if (!(event.key in keys)) return;
      event.preventDefault();
      show(Math.max(0, Math.min(images.length - 1, keys[event.key])));
      thumbs[current]?.focus({ preventScroll: true });
    });
    let dragStart;
    stage?.addEventListener('dragstart', event => { if (desktopGallery.matches) event.preventDefault(); });
    stage?.addEventListener('pointerdown', event => {
      if (!desktopGallery.matches || event.button !== 0 || event.target.closest('button, a, input')) return;
      dragStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
      stage.setPointerCapture(event.pointerId);
      gallery.classList.add('is-gallery-dragging');
    });
    const endDrag = event => {
      if (!dragStart || dragStart.id !== event.pointerId) return;
      const dx = event.clientX - dragStart.x, dy = event.clientY - dragStart.y;
      dragStart = null;
      gallery.classList.remove('is-gallery-dragging');
      if (event.type === 'pointercancel' || !desktopGallery.matches || Math.abs(dx) < 50 || Math.abs(dx) <= Math.abs(dy)) return;
      const target = current + (dx < 0 ? 1 : -1);
      if (gallery.closest('.pdp-snow') && (target < 0 || target >= images.length)) return;
      show(target);
    };
    stage?.addEventListener('pointerup', endDrag);
    stage?.addEventListener('pointercancel', endDrag);
    gallery.addEventListener('product:show-image', event => {
      if (event.detail.galleryUrls?.length === 3 && images.length >= 3) {
        event.detail.galleryUrls.forEach((url, index) => {
          const item = images[index];
          const image = item.querySelector('img');
          const thumb = thumbs[index]?.querySelector('img');
          if (image) {
            const assetSize = width => url.replace(/(?:_\d+x)?(\.[a-z0-9]+)(\?.*)?$/i, `_${width}x$1$2`);
            const snowSourceKey = url.split('?')[0].split('/').pop();
            const refinedView = snowSources[snowSourceKey];
            const refinedFront = index === 0 && event.detail.galleryFrontSrcset;
            image.srcset = refinedView ? refinedView.sources.map(source => `${source.url} ${source.width}w`).join(', ') : refinedFront || [400, 800, 1200, 1600].map(width => `${assetSize(width)} ${width}w`).join(', ');
            if (refinedView) {
              image.width = refinedView.width;
              image.height = refinedView.height;
            } else if (refinedFront) {
              image.width = Number(event.detail.galleryFrontWidth);
              image.height = Number(event.detail.galleryFrontHeight);
            } else {
              image.width = 1536;
              image.height = 1024;
            }
            image.sizes = '(min-width: 1500px) 700px, (min-width: 761px) 50vw, calc(100vw - 32px)';
            image.src = refinedView ? refinedView.fallback : refinedFront ? url : assetSize(1600);
            if (index === 0) setProductFraming(image, event.detail.galleryFrontFrame);
            image.alt = `${event.detail.color} snow goggles, ${['front', 'angle', 'scene'][index]} view`;
          }
          if (thumb) {
            const assetSize = width => url.replace(/(?:_\d+x)?(\.[a-z0-9]+)(\?.*)?$/i, `_${width}x$1$2`);
            const refinedFront = index === 0 && event.detail.galleryFrontSrcset;
            const refinedThumb = refinedFront && refinedFront.split(',')[0].trim().split(/\s+/)[0];
            thumb.srcset = refinedFront ? '' : [90, 120, 180].map(width => `${assetSize(width)} ${width}w`).join(', ');
            thumb.sizes = '62px';
            thumb.src = refinedThumb || assetSize(180);
          }
          if (thumbs[index]) thumbs[index].setAttribute('aria-label', `View ${event.detail.color} image ${index + 1}`);
        });
        show(0, true);
        return;
      }
      const index = images.findIndex(item => item.dataset.mediaId === event.detail.imageId);
      if (index !== -1) {
        restorePrimary();
        show(index);
      } else if (event.detail.imageUrl && primaryImage) {
        primaryImage.removeAttribute('srcset');
        primaryImage.src = event.detail.imageUrl;
        if (primaryThumb && event.detail.thumbUrl) {
          primaryThumb.removeAttribute('srcset');
          primaryThumb.src = event.detail.thumbUrl;
        }
        show(0, true);
      }
    });
    show(current, true);
  });
  document.querySelectorAll('a[href="#fit-guide"]').forEach(link => {
    link.addEventListener('click', () => {
      const guide = document.getElementById('fit-guide');
      if (guide) guide.open = true;
    });
  });
  document.querySelectorAll('[data-variant-select]').forEach(select => {
    const showVariantImage = () => {
      const option = select.selectedOptions[0];
      const gallery = select.closest('.product-layout')?.querySelector('[data-product-gallery]');
      if (!option || !gallery) return;
      if (option.dataset.galleryFront) {
        gallery.dispatchEvent(new CustomEvent('product:show-image', {
          detail: {
            color: option.dataset.option1,
            galleryUrls: [option.dataset.galleryFront, option.dataset.galleryAngle, option.dataset.galleryScene],
            galleryFrontSrcset: option.dataset.galleryFrontSrcset,
            galleryFrontWidth: option.dataset.galleryFrontWidth,
            galleryFrontHeight: option.dataset.galleryFrontHeight,
            galleryFrontFrame: option.dataset.galleryFrontFrame
          }
        }));
      } else if (option.dataset.imageId) {
        gallery.dispatchEvent(new CustomEvent('product:show-image', {
          detail: { imageId: option.dataset.imageId, imageUrl: option.dataset.imageUrl, thumbUrl: option.dataset.thumbUrl }
        }));
      }
    };
    select.addEventListener('change', () => {
      const selectedOption = select.selectedOptions[0];
      const form = select.closest('.product-form');
      form?.querySelectorAll('[data-option-position]').forEach(group => {
        const value = selectedOption?.dataset[`option${group.dataset.optionPosition}`];
        let selectedButton;
        group.querySelectorAll('[data-option-value]').forEach(button => {
          const selected = button.dataset.optionValue === value;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
          if (selected) selectedButton = button;
        });
        const label = group.querySelector('[data-selected-option]');
        if (label && selectedButton) label.textContent = selectedButton.dataset.displayValue || value;
      });
      const addButton = form?.querySelector('.add-to-cart');
      if (addButton && selectedOption) {
        addButton.disabled = selectedOption.disabled;
        addButton.textContent = selectedOption.disabled ? erTranslate('Sold out') : erTranslate('Add to Cart');
      }
      const price = select.closest('.product-info')?.querySelector('[data-product-price]');
      if (price) {
        const option = select.selectedOptions[0];
        const currentPrice = price.querySelector('[data-product-current-price]');
        const comparePrice = price.querySelector('[data-product-compare-price]');
        if (currentPrice && comparePrice) {
          currentPrice.textContent = option?.dataset.price || '';
          const compareValue = option?.dataset.comparePrice || '';
          comparePrice.textContent = compareValue;
          comparePrice.hidden = !compareValue;
          const compareLabel = price.querySelector('[data-product-compare-label]');
          if (compareLabel) compareLabel.hidden = !compareValue;
          price.classList.toggle('is-on-sale', Boolean(compareValue));
        } else {
          price.textContent = option?.dataset.price || '';
        }
      }
      const color = select.closest('.product-info')?.querySelector('[data-product-color]');
      const colorGroup = [...select.closest('.product-form').querySelectorAll('[data-option-position]')]
        .find(group => /^colou?r$/i.test(group.dataset.optionName || ''));
      if (color && colorGroup) color.textContent = colorGroup.querySelector('[data-selected-option]')?.textContent || '';
      showVariantImage();
    });
    // Keep the initial gallery aligned with the selected purchasable variant.
    showVariantImage();
  });

  document.querySelectorAll('.product-form').forEach(form => {
    const select = form.querySelector('[data-variant-select]');
    if (!select) return;
    const groups = [...form.querySelectorAll('[data-option-position]')];
    const addButton = form.querySelector('.add-to-cart');
    groups.forEach(group => group.querySelectorAll('[data-option-value]').forEach(button => {
      button.addEventListener('click', () => {
        group.querySelectorAll('[data-option-value]').forEach(choice => {
          const selected = choice === button;
          choice.classList.toggle('is-selected', selected);
          choice.setAttribute('aria-pressed', String(selected));
        });
        group.querySelector('[data-selected-option]').textContent = button.dataset.displayValue || button.dataset.optionValue;
        const selectedValues = groups.map(item => item.querySelector('[aria-pressed="true"]')?.dataset.optionValue || '');
        const variant = [...select.options].find(option =>
          selectedValues.every((value, index) => option.dataset[`option${index + 1}`] === value)
        );
        if (variant) {
          select.value = variant.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          addButton.disabled = variant.disabled;
          addButton.textContent = variant.disabled ? erTranslate('Sold out') : erTranslate('Add to Cart');
        } else {
          addButton.disabled = true;
          addButton.textContent = erTranslate('Unavailable');
        }
      });
    }));
  });

  document.querySelectorAll('[data-reference-slider]').forEach(slider => {
    const slides = [...slider.querySelectorAll('[data-reference-slide]')];
    const dots = [...slider.querySelectorAll('[data-reference-dot]')];
    if (slides.length < 2) return;
    let current = 0;
    let timer;
    let showVersion = 0;
    const show = index => {
      const requestVersion = ++showVersion;
      current = (index + slides.length) % slides.length;
      const media = slides[current].querySelector("template[data-reference-slide-media]");
      if (media) {
        media.replaceWith(media.content.cloneNode(true));
        const image = slides[current].querySelector('img');
        if (image) {
          image.loading = 'eager';
          image.decode().catch(() => {}).then(() => {
            if (requestVersion === showVersion) show(index);
          });
          return;
        }
      }
      slides.forEach((slide, position) => {
        const active = position === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.querySelectorAll('a').forEach(link => { link.tabIndex = active ? 0 : -1; });
      });
      dots.forEach((dot, position) => {
        dot.classList.toggle('is-active', position === current);
        dot.setAttribute('aria-pressed', String(position === current));
      });
    };
    const restart = () => {
      window.clearInterval(timer);
      if (slider.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = window.setInterval(() => show(current + 1), 6000);
      }
    };
    dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); restart(); }));
    slider.addEventListener('mouseenter', () => window.clearInterval(timer));
    slider.addEventListener('mouseleave', restart);
    slider.addEventListener('focusin', () => window.clearInterval(timer));
    slider.addEventListener('focusout', event => { if (!slider.contains(event.relatedTarget)) restart(); });
    show(0);
    restart();
  });

  document.querySelectorAll('.reference-bestsellers').forEach(section => {
    const track = section.querySelector('[data-carousel-track]');
    const previous = section.querySelector('[data-carousel-prev]');
    const next = section.querySelector('[data-carousel-next]');
    if (!track) return;
    const updateControls = () => {
      previous.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    };
    const scroll = direction => {
      const card = track.querySelector('.reference-best-card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      track.scrollBy({ left: direction * (card.clientWidth + gap), behavior: 'smooth' });
    };
    previous.addEventListener('click', () => scroll(-1));
    next.addEventListener('click', () => scroll(1));
    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
  });

  document.querySelectorAll('.collection-reference-fishing').forEach(section => {
    const track = section.querySelector('[data-fishing-track]');
    const previous = section.querySelector('[data-fishing-prev]');
    const next = section.querySelector('[data-fishing-next]');
    if (!track || !previous || !next) return;
    const updateControls = () => {
      previous.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    };
    const scroll = direction => {
      const card = track.querySelector('.product-card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      track.scrollBy({ left: direction * (card.clientWidth + gap), behavior: 'smooth' });
    };
    previous.addEventListener('click', () => scroll(-1));
    next.addEventListener('click', () => scroll(1));
    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
  });

  document.querySelectorAll('[data-golf-comparison]').forEach(compare => {
    const range = compare.querySelector('[data-golf-comparison-range]');
    if (!range) return;
    range.addEventListener('input', () => {
      compare.style.setProperty('--golf-reveal', `${range.value}%`);
    });
  });

  document.querySelectorAll('[data-fishing-compare]').forEach(compare => {
    const without = compare.querySelector('.fishing-collection-compare-without');
    const withLens = compare.querySelector('.fishing-collection-compare-with');
    const toggle = compare.querySelector('[data-fishing-compare-toggle]');
    if (!without || !withLens || !toggle) return;

    const updateToggle = () => {
      const playing = !without.paused && !withLens.paused;
      toggle.setAttribute('aria-label', playing ? erTranslate('Pause comparison animation') : erTranslate('Play comparison animation'));
      toggle.setAttribute('aria-pressed', String(playing));
      toggle.querySelector('span').textContent = playing ? 'Ⅱ' : '▶';
    };
    const pause = () => {
      without.pause();
      withLens.pause();
      updateToggle();
    };
    const play = () => {
      if (withLens.readyState >= 1) withLens.currentTime = without.currentTime;
      Promise.all([without.play(), withLens.play()]).then(updateToggle, pause);
    };

    without.addEventListener('timeupdate', () => {
      if (withLens.readyState >= 1 && Math.abs(withLens.currentTime - without.currentTime) > .15) {
        withLens.currentTime = without.currentTime;
      }
    });
    const togglePlayback = () => toggle.getAttribute('aria-pressed') === 'true' ? pause() : play();
    toggle.addEventListener('pointerdown', event => {
      event.preventDefault();
      togglePlayback();
    });
    toggle.addEventListener('click', event => {
      if (event.detail === 0) togglePlayback();
    });
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) play();
  });

  document.querySelectorAll('[data-series-tabs]').forEach(section => {
    const tabs = [...section.querySelectorAll('[data-series-tab]')];
    const panels = [...section.querySelectorAll('[data-series-panel]')];
    tabs.forEach(tab => tab.addEventListener('click', () => {
      const selected = tab.dataset.seriesTab;
      tabs.forEach(item => item.setAttribute('aria-selected', String(item === tab)));
      panels.forEach(panel => { panel.hidden = panel.dataset.seriesPanel !== selected; });
    }));
  });
});

// Keep Shopify's product filters while presenting individual shopping choices.
document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.collection-reference-filter-panel form');
  if (!form) return;
  const params = new URLSearchParams(location.search);
  const controls = [];
  const materialNames = [['PC', 'Polycarbonate'], ['TAC', 'TAC'], ['Nylon', 'Nylon'], ['Glass', 'Glass'], ['Resin', 'Resin']];
  const kinds = {
    'Frame Color': [{key:'color', title:'Frame color', labels: text => text.split(',').map(s => s.trim().replace(/\s+Frame$/i,'').replace(/^(Gloss |Matte |Textured )/i,'')).filter(Boolean)}],
    'Fit': [{key:'width', title:'Frame width', labels: text => {
      const width = text.match(/(\d+(?:\.\d+)?)\s*(inch|mm)\s+(?:inner\s+)?frame width/i) || text.match(/(?:inner\s+)?frame width\s+(\d+(?:\.\d+)?)\s*(inch|mm)/i);
      if (!width) return [];
      const n = width[2].toLowerCase() === 'mm' ? Number(width[1]) / 25.4 : Number(width[1]);
      return [n < 5.51 ? 'Under 5.51 inch' : n < 5.91 ? '5.51–5.90 inch' : n < 6.30 ? '5.91–6.29 inch' : '6.30 inch and above'];
    }}],
    'Lens Type': [
      {key:'lens',title:'Lens features',labels:text => [(/polarized/i.test(text) ? erTranslate('Polarized') : ''),(/photochromic/i.test(text) ? erTranslate('Photochromic') : '')].filter(Boolean)},
      {key:'material',title:'Lens material',labels:text => materialNames.filter(([token]) => new RegExp('\\b'+token+'\\b','i').test(text)).map(([,label])=>label)}
    ]
  };
  form.querySelectorAll('.collection-filter').forEach(original => {
    const kind = kinds[original.querySelector('summary')?.textContent.trim()];
    if (!kind) return;
    const source = [...original.querySelectorAll('input[type="checkbox"]')].map(input => ({name:input.name,value:input.value,available:!input.disabled,active:input.checked}));
    if (!source.length) return;
    const replacements = [];
    kind.forEach(spec => {
      const groups = new Map();
      source.forEach(item => spec.labels(item.value).forEach(label => {
        if (!groups.has(label)) groups.set(label,{values:new Set(),available:false});
        const group=groups.get(label);group.values.add(item.value);group.available ||= item.available;
      }));
      if (!groups.size) return;
      const section=document.createElement('details');section.className='collection-filter';
      const summary=document.createElement('summary');summary.textContent=spec.title;section.append(summary);
      const values=document.createElement('div');values.className='collection-filter-values';section.append(values);
      const chosen=params.getAll('er_'+spec.key);
      [...groups].sort(([a],[b])=>spec.key==='width'?0:a.localeCompare(b)).forEach(([label,group])=>{
        const row=document.createElement('label');const input=document.createElement('input');input.type='checkbox';
        input.checked=chosen.includes(label);input.disabled=!group.available&&!input.checked;input.dataset.shoppingFilter=spec.key;
        const caption=document.createElement('span');caption.textContent=label;row.append(input,caption);values.append(row);
        controls.push({input,key:spec.key,label,name:source[0].name,values:group.values});
      });
      section.open=chosen.length>0;replacements.push(section);
    });
    if (replacements.length) original.replaceWith(...replacements);
  });
  form.addEventListener('submit',event=>{
    if (!controls.length) return;
    event.preventDefault();
    const target=new URL(form.action);const next=new URLSearchParams(new FormData(form));
    const managedNames=new Set(controls.map(c=>c.name));managedNames.forEach(name=>next.delete(name));
    const selected=new Map();
    controls.filter(c=>c.input.checked).forEach(c=>{
      next.append('er_'+c.key,c.label);
      if (!selected.has(c.name)) selected.set(c.name,new Map());
      if (!selected.get(c.name).has(c.key)) selected.get(c.name).set(c.key,new Set());
      c.values.forEach(value=>selected.get(c.name).get(c.key).add(value));
    });
    selected.forEach((groups,name)=>{
      const sets=[...groups.values()];
      const values=[...sets[0]].filter(value=>sets.every(set=>set.has(value)));
      if (!values.length) next.append(name,'__no_matching_lens_option__');
      else values.forEach(value=>next.append(name,value));
    });
    target.search=next.toString();location.assign(target.href);
  });
  // Sorting must keep the customer's visible filter choices.
  document.querySelectorAll('.collection-reference-sort').forEach(sortForm=>{
    params.forEach((value,name)=>{if (!/^er_(color|width|lens|material)$/.test(name)) return;
      const input=document.createElement('input');input.type='hidden';input.name=name;input.value=value;sortForm.append(input);
    });
  });
});

/* EMBER ROVE attention analytics v1.0.0. Uses Shopify consent and custom events only. */
(() => {
  'use strict';
  if (window.__erAttentionInstalled) return;
  window.__erAttentionInstalled = true;
  const boot = () => {
    const main = document.querySelector('main, #MainContent');
    if (!main) return;
    const path = location.pathname;
    const pageType = /^\/products\//.test(path) ? 'product' : /^\/policies\//.test(path) ? 'policy' : /^\/pages\//.test(path) ? 'service' : /^\/blogs\//.test(path) ? 'guide' : /^\/collections\//.test(path) ? 'collection' : /^\/search/.test(path) ? 'search' : /^\/cart/.test(path) ? 'cart' : 'other';
    const slug = s => String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '').slice(0, 100);
    const topicFor = s => {
      s = String(s || '').toLowerCase().replace(/[-_]/g,' ');
      const rules = [
        ['privacy', /privacy|cookie|personal data|sell.*data/], ['returns', /return|exchange|refund/],
        ['warranty', /warranty|protection program|accidental|lifetime|order terms/],
        ['shipping_cost', /shipping rates|shipping options|free.*shipping|shipping.*free|shipping.*cost/],
        ['delivery_time', /delivery|dispatch|processing|transit|shipping.*time|shipping information|shipping destinations/],
        ['material', /tr90|polycarbonate|lens material/],
        ['fit', /fit|dimensions|nose pad|temple|weight|helmet|over.glasses|otg|position/],
        ['lens_function', /uv400|polariz|photochrom|lens|vlt|uva|uvb/],
        ['material', /tr90|material|polycarbonate|durab|frame construction/],
        ['care', /care for|clean|care between|maintenance/], ['appearance', /colou?r|half.rim|shape|profile|style|look/],
        ['price', /price|discount|coupon|offer|promotion/], ['reviews', /review|rating|testimonial/],
        ['support', /contact|help|question|faq|support/], ['use_case', /ride|cycling|fishing|golf|snow|trail|adventure/]
      ];
      return rules.find(r => r[1].test(s))?.[0] || 'general';
    };
    if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], () => {});
    }
    const allowed = () => {
      try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; } catch (_) { return false; }
    };
    const getStore = key => { try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (_) { return null; } };
    const putStore = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {} };
    const removeStore = key => { try { sessionStorage.removeItem(key); } catch (_) {} };
    let productId = null;
    if (pageType === 'product') {
      document.querySelectorAll('script[type="application/ld+json"]').forEach(el => {
        try { const p = JSON.parse(el.textContent); if (p.productGroupID) productId = String(p.productGroupID); } catch (_) {}
      });
      if (!productId) productId = document.querySelector('form[action*="/cart/add"]')?.getAttribute('id')?.match(/product_form_(\d+)/)?.[1] || null;
    }
    const selectedVariant = () => document.querySelector('[data-variant-select], form[action*="/cart/add"] [name="id"]')?.value || null;
    let pageViewId = null, entry = null, lastProduct = null, internal = false;
    const setupContext = () => {
      if (!allowed() || pageViewId) return;
      pageViewId = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      const now = Date.now();
      const context = getStore('er_attention_context');
      if (context && now - context.at < 1800000) {
        lastProduct = context.product_id || null;
        internal = context.is_internal === true;
        entry = getStore('er_attention_entry');
        if (entry && (entry.target_path !== path || now - entry.at > 60000)) entry = null;
      }
      if (new URLSearchParams(location.search).get('er_analytics_test') === '1') internal = true;
      const ref = document.referrer;
      const postSale = /\/(account|orders|checkouts)(\/|$)/.test(ref ? new URL(ref).pathname : '');
      if (postSale) lastProduct = null;
      if (productId) lastProduct = productId;
      putStore('er_attention_context', {at:now, product_id:lastProduct, is_internal:internal, post_sale:!productId && (postSale || (context && now-context.at<1800000 && context.post_sale === true))});
      removeStore('er_attention_entry');
    };
    const phase = () => getStore('er_attention_context')?.post_sale ? 'post_purchase' : productId || entry?.product_id || lastProduct ? 'shopping' : 'unknown';
    const publish = (name, fields = {}) => {
      if (!allowed() || typeof window.Shopify?.analytics?.publish !== 'function') return false;
      setupContext();
      const context = getStore('er_attention_context');
      if (context) putStore('er_attention_context', {...context, at:Date.now()});
      try {
        const result = Shopify.analytics.publish(`ember_rove:${name}`, {
          tracking_version:'attention_1', page_type:pageType, page_view_id:pageViewId,
          product_id:productId, variant_id:productId ? selectedVariant() : null,
          origin_product_id:entry?.product_id || lastProduct, entry_location:entry?.location || 'direct_or_referrer',
          shopping_phase:phase(), is_internal:internal, ...fields
        });
        if (result?.catch) result.catch(() => {});
        return true;
      } catch (_) { return false; }
    };
    const records = [], byElement = new Map(), ids = new Map();
    const add = (el, label, type = 'content') => {
      if (!el || byElement.has(el) || !label) return;
      const base = slug(el.getAttribute('data-analytics-module') || el.id || label);
      const n = (ids.get(base) || 0) + 1; ids.set(base, n);
      const record = {el, fields:{module_id:base+(n>1?`_${n}`:''), content_topic:el.getAttribute('data-analytics-topic') || topicFor(label+' '+el.className+(el.tagName==='ARTICLE'?' '+el.textContent.slice(0,500):'')), module_type:type}, total:0, lastFlushed:0, seen:false, sent:new Set(), started:null};
      records.push(record); byElement.set(el, record);
    };
    main.querySelectorAll('details').forEach(el => add(el, el.querySelector('summary')?.textContent.trim(), 'accordion'));
    main.querySelectorAll('section, article, [data-analytics-module]').forEach(el => {
      if (el.matches('.product-page, .care-page, .pdp-related-card') || el.querySelector('.product-layout')) return;
      const h = el.querySelector('h2, h3');
      if (h && !h.closest('details') && el.children.length && (!el.matches('article') || !el.querySelector('section'))) add(el, h.textContent.trim(), 'content');
    });
    main.querySelectorAll('h2, h3').forEach(h => {
      if (h.closest('.pdp-related-card')) return;
      const next = h.nextElementSibling;
      if (next && !byElement.has(next) && !next.matches('h2,h3,section,article,details,form') && (!h.closest('section:not(.product-page), article:not(.care-page)') || h.closest('details,.shopify-policy__body,.rte,.page-copy,.page-content'))) add(next, h.textContent.trim(), 'paragraph');
    });
    const priceEl=main.querySelector('[data-product-price]'), galleryEl=main.querySelector('[data-product-gallery]');
    add(priceEl, erTranslate('Price'), 'price'); if(byElement.has(priceEl)) byElement.get(priceEl).fields.module_id='product_price';
    add(galleryEl, 'Product images', 'gallery'); if(byElement.has(galleryEl)) {byElement.get(galleryEl).fields.module_id='product_gallery';byElement.get(galleryEl).fields.content_topic='appearance';}
    main.querySelectorAll('[data-option-position]').forEach(el=>add(el,el.dataset.optionName||'Color and options','options'));
    // yotpo_analytics_1: register rendered widgets loaded after page boot.
    // Unknown Yotpo products are excluded instead of guessed as Loyalty.
    const yotpoSelector = '.yotpo-main-widget, .yotpo-bottomline, #yotpo-reviews-main-widget, .yotpo-widget-instance, .yotpo-widget-loyalty-page, .yotpo-banner-layout, .yotpo-drawer-layout';
    const yotpoType = el => {
      if (el.matches('.yotpo-main-widget, .yotpo-bottomline, #yotpo-reviews-main-widget') || el.querySelector('.yotpo-main-widget, .yotpo-bottomline, #yotpo-reviews-main-widget, .yotpo-reviews-main-widget, .yotpo-star-rating, .yotpo-reviews-star-ratings-widget, .yotpo-reviews-carousel')) return 'yotpo_reviews';
      if (el.matches('.yotpo-banner-layout, .yotpo-drawer-layout') && el.closest('.yotpo-widget-loyalty-floater-widget')) return 'yotpo_loyalty';
      if (el.matches('.yotpo-widget-loyalty-page') || el.querySelector('.yotpo-widget-loyalty-page, .yotpo-widget-my-rewards, .yotpo-widget-redeem-points, .yotpo-widget-referral, .yotpo-widget-earning-points')) return 'yotpo_loyalty';
      return null;
    };
    const registerYotpo = () => document.querySelectorAll(yotpoSelector).forEach(el => {
      const type = yotpoType(el);
      if (!type || !el.childElementCount || byElement.has(el)) return;
      // Prefer the outer widget instance; nested elements are not separate modules.
      if (el.parentElement?.closest(yotpoSelector)) return;
      const label = type + '_' + (el.getAttribute('data-yotpo-instance-id') || el.id || 'widget');
      add(el, label, type);
      const r = byElement.get(el);
      if (r) Object.assign(r.fields, {module_id:slug(label), module_type:type, content_topic:type==='yotpo_reviews'?'reviews':'loyalty'});
    });
    let yotpoScanPending = false;
    const yotpoObserver = new MutationObserver(() => {
      if (yotpoScanPending) return;
      yotpoScanPending = true;
      requestAnimationFrame(() => { yotpoScanPending=false; registerYotpo(); });
    });
    yotpoObserver.observe(document.body,{childList:true,subtree:true});
    registerYotpo();
    document.addEventListener('click', event => {
      const control = event.target.closest('button, a, [role="button"], select, .yotpo-banner-layout, .yotpo-drawer-sign-in-link, .yotpo-drawer-sign-up-item, .yotpo-close-icon');
      const root = control?.closest(yotpoSelector);
      const outer = root?.parentElement?.closest(yotpoSelector) || root;
      const record = byElement.get(outer);
      if (record && ['yotpo_reviews','yotpo_loyalty'].includes(record.fields.module_type)) {
        publish('feature_interacted',{...record.fields, interaction_type:'widget_control_click'});
      }
    },true);
    // Read time requires content visibility, foreground tab, and recent interaction.
    let lastActivity = performance.now(), lastTick = performance.now();
    ['pointerdown','keydown','scroll','touchstart'].forEach(name => document.addEventListener(name, () => { lastActivity = performance.now(); }, {passive:true}));
    const visible = el => {
      const closed=el.closest('details:not([open])');
      if (closed && closed!==el && !(el.tagName==='SUMMARY'&&el.parentElement===closed)) return false;
      if (el.tagName === 'DETAILS' && !el.open) return false;
      if (el.closest('[hidden], [aria-hidden="true"]')) return false;
      const r = el.getBoundingClientRect();
      if (!r.width || !r.height || getComputedStyle(el).visibility === 'hidden') return false;
      const vh = Math.max(0, Math.min(r.bottom, innerHeight) - Math.max(r.top, 0));
      const vw = Math.max(0, Math.min(r.right, innerWidth) - Math.max(r.left, 0));
      return vh >= Math.min(r.height, innerHeight) * .5 && vw >= Math.min(r.width, innerWidth) * .5;
    };
    let pageSent=null;
    const tick = () => {
      const now = performance.now(), dt = Math.min(now-lastTick, 1500); lastTick = now;
      if (!allowed() || document.visibilityState !== 'visible' || now-lastActivity > 30000) { records.forEach(r => {r.started=null;}); return; }
      setupContext();
      if(pageSent!==pageViewId&&publish('content_page_viewed',{module_id:'page',content_topic:topicFor(path)})) {pageSent=pageViewId;reportServiceResults();}
      records.forEach(r => {
        const exposureTarget=r.el.tagName==='DETAILS'&&!r.el.open?r.el.querySelector('summary'):r.el;
        if (!exposureTarget || !visible(exposureTarget)) { r.started=null; return; }
        if (r.started === null) { r.started=now; return; }
        if (!r.seen && now-r.started >= 1000 && publish('module_exposed', r.fields)) r.seen=true;
        if ((r.el.tagName==='DETAILS'&&!r.el.open)||r.fields.module_type==='link') return;
        r.total = Math.min(r.total+dt,3600000);
        [5000,15000].forEach(ms => {
          if (r.seen && r.total>=ms && !r.sent.has(ms) && publish('module_engaged',{...r.fields, engagement_threshold_ms:ms, active_time_ms:Math.round(r.total)})) r.sent.add(ms);
        });
      });
    };
    let timer = setInterval(tick, 500);
    const flush = () => records.forEach(r => { if (r.seen && r.total-r.lastFlushed>=500 && publish('module_time',{...r.fields, active_time_ms:Math.round(r.total)})) r.lastFlushed=r.total; });
    let heartbeat=setInterval(flush,15000);
    document.addEventListener('visibilitychange', () => { if (document.visibilityState==='hidden') flush(); records.forEach(r=>{r.started=null;}); lastTick=performance.now(); });
    window.addEventListener('pagehide', () => {flush(); clearInterval(timer); clearInterval(heartbeat);});
    window.addEventListener('pageshow', event => { if(event.persisted) {lastTick=performance.now();lastActivity=lastTick;timer=setInterval(tick,500);heartbeat=setInterval(flush,15000);} });
    document.addEventListener('visitorConsentCollected', () => {
      if (!allowed()) { ['er_attention_context','er_attention_entry'].forEach(removeStore); pageViewId=null; entry=null; lastProduct=null; internal=false; records.forEach(r=>{r.total=0;r.lastFlushed=0;r.started=null;r.seen=false;r.sent.clear();}); }
    });
    main.addEventListener('toggle', event => {
      const r=byElement.get(event.target);
      if (event.target.tagName==='DETAILS' && event.target.open && r) publish('content_opened',r.fields);
    },true);
    const placement = el => el.closest('footer,.site-footer,#shopify-section-footer') ? 'footer' : el.closest('header,#shopify-section-header') ? 'header' : pageType==='cart' ? 'cart' : el.closest('.product-info') ? 'product_summary' : el.closest('main,#MainContent') ? 'page_content' : 'other';
    document.querySelectorAll('a[href]').forEach(el=>{
      let u;try{u=new URL(el.href,location.href);}catch(_){return;}
      if(u.origin!==location.origin||!/^\/(pages|policies|blogs)\//.test(u.pathname))return;
      add(el,'link_'+slug(u.pathname)+'_'+placement(el),'link');
      const r=byElement.get(el);if(r) Object.assign(r.fields,{content_topic:topicFor(u.pathname+' '+el.textContent),entry_location:placement(el),target_path:u.pathname});
    });
    const mediaType = image => {
      const text=(image?.getAttribute('alt')||'')+' '+(image?.getAttribute('src')||'');
      return /dimension|measurement|size|fit.diagram/i.test(text) ? 'dimensions' : /model|wear|lifestyle|scene/i.test(text) ? 'wearing_or_scene' : /detail|close.up|nose.pad|temple/i.test(text) ? 'detail' : /front/i.test(text) ? 'front' : /angle|side/i.test(text) ? 'angle' : /lens|polar|uv400|technology/i.test(text) ? 'function' : 'unclassified';
    };
    document.addEventListener('click', event => {
      const el=event.target.closest('a,button,input'); if(!el) return;
      if (el.matches('[data-gallery-thumb],[data-gallery-prev],[data-gallery-next]')) {
        setTimeout(()=>{
          const gallery=el.closest('[data-product-gallery]'), image=gallery?.querySelector('[data-gallery-image]:not([hidden]) img');
          const active=gallery?.querySelector('[data-gallery-thumb][aria-pressed="true"]');
          publish('gallery_image_viewed',{...byElement.get(gallery)?.fields,content_topic:'appearance',module_id:'product_gallery',module_type:'gallery',media_index:Number(active?.dataset.galleryThumb||0),media_type:mediaType(image),interaction_type:'manual'});
        },0);
      }
      if(el.matches('[data-option-value]')) setTimeout(()=>{
        const group=el.closest('[data-option-position]'), select=document.querySelector('[data-variant-select]');
        publish('variant_selected',{...byElement.get(group)?.fields,content_topic:/colou?r/i.test(group?.dataset.optionName||'')?'appearance':'fit',module_id:byElement.get(group)?.fields.module_id||'product_options',option_name:group?.dataset.optionName||'option',option_value:el.dataset.displayValue||el.dataset.optionValue, availability:!!select?.selectedOptions?.[0]&&!select.selectedOptions[0].disabled});
      },0);
      if(el.matches('.add-to-cart') && !window.EmberRoveBehavior?.ready()) publish('add_to_cart_attempted',{module_id:'purchase_action',content_topic:'purchase',availability:!el.disabled});
      if(el.tagName !== 'A') return;
      let url; try {url=new URL(el.href,location.href);} catch(_){return;}
      if(url.protocol==='mailto:'||url.protocol==='tel:') { publish('service_action',{content_topic:'support',module_id:'contact',service_action:url.protocol==='mailto:'?'email_click':'phone_click',entry_location:placement(el)}); return; }
      if(url.origin!==location.origin) return;
      const target=url.pathname, related=/^\/(pages|policies|blogs)\//.test(target);
      if(related||url.hash==='#fit-guide') {
        const fields={...byElement.get(el)?.fields,content_topic:topicFor(target+' '+el.textContent),module_id:byElement.get(el)?.fields.module_id||'content_link',target_path:target,entry_location:placement(el)};
        publish('content_link_clicked',fields);
        if(allowed() && target!==path) putStore('er_attention_entry',{at:Date.now(),target_path:target,product_id:productId||lastProduct,location:fields.entry_location});
      }
      if(/^\/products\//.test(target)&&target!==path) publish('product_card_clicked',{content_topic:'product_discovery',module_id:'product_link',target_path:target,entry_location:placement(el)});
    });
    main.addEventListener('change',event=>{
      const el=event.target;
      if(el.matches('[data-golf-comparison-range]')) publish('feature_interacted',{module_id:'lens_comparison',content_topic:'lens_function',interaction_type:'comparison_adjusted'});
      if(el.matches('[data-variant-select]') && event.isTrusted) publish('variant_selected',{module_id:'product_options',content_topic:'appearance',option_name:'variant',option_value:el.selectedOptions[0]?.textContent.trim(),availability:!el.selectedOptions[0]?.disabled});
      if(el.matches('[data-sort-select]')) publish('collection_sort_changed',{module_id:'collection_sort',content_topic:'product_discovery',sort_key:el.value});
      if(el.matches('input[type="checkbox"]')&&el.closest('.collection-filter,.collection-filter-form,form[action*="/collections"]')) publish('collection_filter_applied',{module_id:'collection_filter',content_topic:'product_discovery',filter_count:el.closest('form')?.querySelectorAll('input[type="checkbox"]:checked').length||0,option_name:el.dataset.shoppingFilter||slug(el.name),option_value:el.closest('label')?.textContent.trim().slice(0,100)});
    },true);
    main.addEventListener('play',event=>{if(event.target.tagName==='VIDEO'&&!event.target.autoplay) publish('feature_interacted',{module_id:'content_video',content_topic:topicFor(path),interaction_type:'video_play'});},true);
    main.addEventListener('submit',event=>{
      const f=event.target, action=f.getAttribute('action')||'';
      if(action.includes('/contact')) publish('service_action',{module_id:'contact_form',content_topic:'support',service_action:'form_submit_attempt'});
      if(action.includes('/search')) publish('service_action',{module_id:'search',content_topic:'product_discovery',service_action:'search_submit'});
    },true);
    function reportServiceResults() {
    if(pageType==='search' && main.querySelector('.empty-state,.search-empty,[data-search-empty]')) publish('service_result',{module_id:'search',content_topic:'product_discovery',service_action:'search',service_status:'no_results'});
    if(main.querySelector('.form-status--success,.form-message--success,[data-form-success]')) publish('service_result',{module_id:'contact_form',content_topic:'support',service_action:'form_submit',service_status:'success'});
    if(main.querySelector('.form-status--error,.errors,[data-form-error]')) publish('service_result',{module_id:'contact_form',content_topic:'support',service_action:'form_submit',service_status:'error'});
    }
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();
})();

/* EMBER ROVE behavior_2: consented action results and atomic policy visibility. */
(() => {
  'use strict';
  if (window.EmberRoveBehavior) return;
  const VERSION = 'behavior_2';
  const STORE = 'er_behavior_context_v2';
  const path = location.pathname;
  const uuid = () => crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const read = () => { try { return JSON.parse(sessionStorage.getItem(STORE) || 'null'); } catch { return null; } };
  const write = value => { try { sessionStorage.setItem(STORE, JSON.stringify(value)); } catch {} };
  const allowed = () => { try { return Shopify.customerPrivacy.analyticsProcessingAllowed() === true; } catch { return false; } };
  const ready = () => allowed() && typeof window.Shopify?.analytics?.publish === 'function';
  const hash = text => { let h = 2166136261; for (const c of text) { h ^= c.charCodeAt(0); h = Math.imul(h, 16777619); } return (h >>> 0).toString(16); };
  const safePath = raw => { try { const p = new URL(raw, location.href).pathname; return /^\/(checkouts|account|orders)(\/|$)/.test(p) ? '/' + p.split('/')[1] : p; } catch { return null; } };
  const numeric = s => { const v=String(s || '').replace(/[^0-9.]/g, '');if(!v)return null;const n=Number(v);return Number.isFinite(n)&&n>=0?n:null; };
  let pageViewId = null, context = null, currentAction = null, lastActivity = performance.now(), lastActivityAt=new Date().toISOString(), lastCheckout=-Infinity;
  const actions = new Set(), records = [], byElement = new WeakMap();
  const productForm = () => document.querySelector('.product-page form[action*="/cart/add"]');
  const productFields = form => {
    form ||= productForm();
    const price = document.querySelector('[data-product-price]');
    return {product_id:form?.getAttribute('id')?.match(/product_form_(\d+)/)?.[1] || null,
      variant_id:form?.querySelector('[name="id"]')?.value || null,
      display_price:numeric(form?.querySelector('[name="id"]')?.selectedOptions?.[0]?.dataset.price || price?.querySelector('[data-product-current-price]')?.textContent || price?.textContent),
      currency:window.Shopify?.currency?.active || null,
      availability:form?.querySelector('[name="id"]')?.selectedOptions?.[0] ? !form.querySelector('[name="id"]').selectedOptions[0].disabled : null,
      button_enabled:form?.querySelector('.add-to-cart') ? !form.querySelector('.add-to-cart').disabled : null};
  };
  const refreshContext = () => {
    if (!ready()) return false;
    const now = Date.now(), saved = read();
    context = saved && now - saved.at < 1800000 ? saved : {purchase_stage:'pre_purchase'};
    const p = productFields();
    if (p.product_id) Object.assign(context, {product_id:p.product_id,variant_id:p.variant_id,display_price:p.display_price,display_price_currency:p.currency});
    context.is_internal = context.is_internal === true || new URLSearchParams(location.search).get('er_analytics_test') === '1';
    context.at = now; write(context);
    pageViewId ||= uuid();
    return true;
  };
  const emit = (name, fields = {}) => {
    try {
      if (!refreshContext()) return false;
      const product=productFields();
      window.ERPurchaseNavigation?.observe(name, {...product, is_internal:context.is_internal === true, ...fields});
      const result = Shopify.analytics.publish('ember_rove:' + name, {
        tracking_version:VERSION,page_view_id:pageViewId,page_type:/^\/products\//.test(path)?'product':/^\/cart/.test(path)?'cart':/^\/(pages|policies)\//.test(path)?'policy':'other',
        origin_product_id:context.product_id || null,purchase_stage:context.purchase_stage || 'pre_purchase',
        ...window.ERCartAnalytics?.context(),is_internal:context.is_internal === true,last_interaction_at_utc:lastActivityAt,...product,display_price:product.display_price??context.display_price??null,display_price_currency:product.currency||context.display_price_currency||null,variant_id:product.variant_id||context.variant_id||null,...fields
      });
      result?.catch?.(() => {});
      return true;
    } catch { return false; }
  };
  const beginAdd = (form,extra={}) => {
    if (!ready()) return null;
    refreshContext();context.purchase_stage='pre_purchase';write(context);
    const a = {id:uuid(),start:performance.now(),form,fields:{...productFields(form),...extra},quantity:Number(new FormData(form).get('quantity') || 1),done:false,seq:0};
    currentAction = a; actions.add(a);
    emit('add_to_cart_attempted',{...a.fields,module_id:'purchase_action',content_topic:'purchase',module_type:'purchase_action',action_id:a.id,requested_quantity:a.quantity,entry_location:'product_form'});
    return a;
  };
  const beginAddItems=(items,entry,kind='accessory')=>{
    if(!ready()||!items?.length)return null;
    refreshContext();context.purchase_stage='pre_purchase';write(context);
    const line=items[0],a={id:uuid(),start:performance.now(),fields:{product_id:null,variant_id:String(line.id),display_price:null,display_price_currency:window.Shopify?.currency?.active||null,availability:null,button_enabled:true,offer_type:kind},quantity:Number(line.quantity||1),done:false,seq:0};
    currentAction=a;actions.add(a);emit('add_to_cart_attempted',{...a.fields,module_id:'purchase_action',content_topic:'purchase',module_type:'purchase_action',action_id:a.id,requested_quantity:a.quantity,entry_location:entry});return a;
  };
  const result = (a, outcome, fields = {}, final = true) => {
    if (!a || a.done) return;
    emit('add_to_cart_result',{...a.fields,module_id:'purchase_action',content_topic:'purchase',module_type:'purchase_action',action_id:a.id,requested_quantity:a.quantity,latency_ms:Math.round(performance.now()-a.start),outcome,result_sequence:++a.seq,result_final:final,...fields});
    a.outcome=outcome;
    if (final) { a.done = true; clearTimeout(a.timer); actions.delete(a); }
  };
  const request = a => {
    if (!a) return;
    emit('add_to_cart_requested',{...a.fields,module_id:'purchase_action',content_topic:'purchase',module_type:'purchase_action',action_id:a.id,requested_quantity:a.quantity});
    a.timer = setTimeout(() => result(a,'unknown',{error_category:'awaiting_response'},false),15000);
  };
  const errorCategory = (status, description = '') => /sold out|stock|inventory|already.*cart|not available/i.test(description) ? 'inventory_or_availability'
    : status === 429 ? 'rate_limit' : status >= 500 ? 'server_error' : status === 403 ? 'forbidden' : status === 404 ? 'not_found' : 'request_rejected';
  const guard=fn=>(...args)=>{try{return fn(...args);}catch{return null;}};
  window.EmberRoveBehavior = {ready,beginAdd:guard(beginAdd),beginAddItems:guard(beginAddItems),request:guard(request),result:guard(result),errorCategory,emit};

  const policyFor = p => !/^\/(pages|policies)\//.test(p)?null:/shipping/.test(p)?'shipping':/return|refund/.test(p)?'returns':/protection|warranty/.test(p)?'protection':/privacy|cookie|do-not-sell|data-sharing/.test(p)?'privacy':/reward|affiliate|terms/.test(p)?'terms':/help-center|contact/.test(p)?'support':null;
  const country = text => /united states|u\.s\.|\bUS\$|\bUSA\b/i.test(text)?'US':/united kingdom|u\.k\./i.test(text)?'GB':/australia/i.test(text)?'AU':/canada/i.test(text)?'CA':null;
  const currency = text => /a\$|aud/i.test(text)?'AUD':/c\$|cad/i.test(text)?'CAD':/£|gbp/.test(text)?'GBP':/\$|usd/.test(text)?'USD':null;
  const textOf = e => (e?.textContent || '').replace(/\s+/g,' ').trim();
  const visibleStyle = e => {const modal=document.querySelector('dialog[open]');return (!modal||modal.contains(e))&&!e.closest('[hidden],[aria-hidden="true"]')&&!e.closest('details:not([open])')&&getComputedStyle(e).visibility!=='hidden';};
  const io = new IntersectionObserver(entries => {
    for (const x of entries) { const r=byElement.get(x.target); if (r) r.visible=x.isIntersecting && x.intersectionRatio>=0.5; }
  },{threshold:[0,0.5,1]});
  const add = (el, id, topic, fields = {}) => {
    if (!el || byElement.has(el)) return;
    const r={el,id,topic,fields,visible:false,continuous:0,total:0,active:0,lastFlushed:0,seen:false,lastSeen:null,lastActive:null};
    records.push(r);byElement.set(el,r);io.observe(el);
  };
  const collectOffers=()=>{
    document.querySelectorAll('[data-mystery-offer],[data-cart-inserts],[data-insert-choice]').forEach((el,i)=>{
      if(byElement.has(el))return;
      const mystery=el.matches('[data-mystery-offer]'),kind=mystery?'mystery':'accessory';
      const box=el.matches('input')?el.closest('label')||el.parentElement:el;
      const anchor=el.matches('input')?box:box.querySelector('h2,h3,legend,[data-mystery-price]')||box;
      const variant=el.querySelector?.('[data-mystery-style]:checked')?.value||el.querySelector?.('[data-cart-insert-choice]')?.value||(el.matches('input')?el.value:null);
      const fields={product_id:null,display_price:numeric(box.querySelector('[data-mystery-price],b,[data-insert-price]')?.textContent),display_price_currency:window.Shopify?.currency?.active||null,offer_type:kind,offer_id:el.dataset.mysteryHandle||variant||'insert',variant_id:variant||null,policy_id:'offer_'+kind,policy_version:'offer2-'+hash(textOf(box)),entry_location:el.closest('[data-cart-drawer]')?'cart_drawer':el.closest('.product-form')?'product_form':'cart_page'};
      add(anchor,'offer_'+kind+'_'+i,'offer',fields);
      box.querySelectorAll('p,small,li').forEach((node,j)=>{if(!node.querySelector('p,li')&&/final.sale|no change.of.mind|non.refund|statutory/i.test(textOf(node)))add(node,'offer_terms_'+kind+'_'+i+'_'+j,'offer_terms',fields);});
    });
  };
  const policyFields = root => ({policy_id:policyFor(path),policy_version:'p2-'+hash(textOf(root))});
  const collectPolicies = () => {
    const main=document.querySelector('main'); if(!main)return;
    const policy=policyFor(path);
    const root=main.querySelector('.care-page,.shopify-policy__container,.page-copy,.page-content,.rte') || main;
    const base=policy?policyFields(root):{};
    // Explicitly register the H1-only first screen; generic H2/H3 tracking misses it.
    main.querySelectorAll('.er-care-benefit,.er-care-free,.er-care-response').forEach((el,i)=>add(el,'protection_hero_'+i,['warranty_period','warranty_period','free_defect_remedy','support_response'][i],{...base,policy_id:'protection'}));
    const areas=policy?[root]:[...main.querySelectorAll('[data-shipping-returns],[data-protection-warranty]')];
    for(const area of areas){
      const inferred=policy || (area.matches('[data-protection-warranty]')?'protection':'shipping_returns');
      const fields={...base,policy_id:inferred,policy_version:base.policy_version||'p2-'+hash(textOf(area))};
      // Transit time is its own cell: the rate cells in the same row are separate topics.
      area.querySelectorAll('.care-rate-card table tbody tr').forEach((row,i)=>{
        const card=row.closest('.care-rate-card'), tag=card.querySelector('.care-tag')?.textContent||'', heading=row.querySelector('th'), label=textOf(heading), range=label.match(/(\d+)\s*[–-]\s*(\d+)\s*(business|calendar)?\s*days/i);
        const co=country(tag),cur=currency(textOf(card)),threshold=numeric(card.querySelector('thead th:nth-child(2)')?.textContent);
        const snapshot={...fields,displayed_country_code:co,currency:cur,service_level:/express/i.test(label)?'express':'standard',transit_days_min:range?Number(range[1]):null,transit_days_max:range?Number(range[2]):null,day_basis:/business/i.test(label)?'business':'calendar',free_shipping_threshold:threshold};
        add(heading,'shipping_time_'+co+'_'+i,'delivery_time',snapshot);
        row.querySelectorAll('td').forEach((td,j)=>add(td,'shipping_fee_'+co+'_'+i+'_'+j,'shipping_cost',{...snapshot,displayed_shipping_amount:/free/i.test(textOf(td))?0:numeric(textOf(td)),fee_condition:j===0?'below_threshold':'at_or_above_threshold'}));
      });
      const candidates=area.querySelectorAll('p,li,h2,h3,.er-protection-metric,.er-protection-remedy,.er-protection-fees>div');
      let n=0;
      for(const el of candidates){
        if(el.closest('table')||el.querySelector('p,li')||el.closest('form'))continue;
        const t=textOf(el);if(t.length<12||t.length>1600)continue;
        let topic=null,extra={};
        if(/1 business day|within one business day/i.test(t)){topic='support_response';extra.reply_business_days=1;}
        else if(/locked|fixed.*fee|19\.90|16\.90/i.test(t)){topic='replacement_fee';extra.displayed_fee=/19\.90/.test(t)?19.90:/16\.90/.test(t)?16.90:null;extra.fee_lock_basis=/lock|fixed/i.test(t)?'purchase_locked':'request_time';}
        else if(/excluded|does not cover|not participate|not included|one.*replacement|one.*allowance|does not restart/i.test(t))topic='coverage_limits';
        else if(/defect|manufacturing/i.test(t)&&/free/i.test(t))topic='free_defect_remedy';
        else if(/24.month|12.month|24 months|12 months|materials.*workmanship|lens coating/i.test(t))topic='warranty_period';
        else if(/postage|\$6\.95|refund.*deduct|free.*exchange|pay.*return|return.*cost/i.test(t)){topic='return_cost';extra.return_fee=/6\.95/.test(t)?6.95:null;}
        else if(/30.days|14.days|original condition|try.on|statutory cancellation|final sale|mystery|outlet/i.test(t)){topic='return_eligibility';extra.return_window_days=/30/.test(t)?30:/14/.test(t)?14:null;}
        else if(/days|delivery time|processing|dispatch.*within|carrier.*accept/i.test(t)){topic='delivery_time';extra.processing_days_max=/two business days/i.test(t)?2:null;}
        else if(/china|where.*ship|local dispatch|local warehouse|return destination/i.test(t)){topic='dispatch_or_return_origin';extra.dispatch_region=/china/i.test(t)?'CN':null;}
        else if(/shipping.*(?:fee|cost|free)|free.*shipping|threshold|import charges/i.test(t))topic='shipping_cost';
        else if(inferred==='privacy'||inferred==='terms')topic=inferred;
        if(topic)add(el,inferred+'_'+topic+'_'+(++n)+'_'+hash(t),topic,{...fields,displayed_country_code:country(textOf(el.closest('.care-card')||el)),currency:currency(t),...extra});
      }
    }
    document.querySelectorAll('.add-to-cart,[data-sticky-add]').forEach((el,i)=>add(el,'purchase_action_'+i,'purchase_action',{}));
  };
  const fieldsFor = r => ({module_id:r.id,content_topic:r.topic,module_type:r.topic==='purchase_action'?'purchase_action':'policy_content',...r.fields,
    active_time_ms:Math.round(r.active),visible_time_ms:Math.round(r.total),content_seen_at_utc:r.lastActive||r.lastSeen});
  const flush = force => {
    for(const r of records)if(r.seen&&(force||r.total-r.lastFlushed>=1000)){
      if(r.topic!=='purchase_action')emit('policy_content_time',fieldsFor(r));r.lastFlushed=r.total;
    }
    if(pageActive>0&&(force||pageActive-pageLastFlushed>=1000)){emit('page_activity_time',{module_id:'page',content_topic:'page_activity',active_time_ms:Math.round(pageActive)});pageLastFlushed=pageActive;}
  };
  let pageActive=0,pageLastFlushed=0,lastTick=performance.now(),started=false,noticeKey=null,noticeStart=0,noticeVisible=false;
  const tick = () => {
    const now=performance.now(),delta=Math.min(1000,Math.max(0,now-lastTick));lastTick=now;
    if(!ready())return;
    if(!started){refreshContext();collectPolicies();collectOffers();emit('behavior_page_viewed',{policy_id:policyFor(path)});started=true;}
    const foreground=document.visibilityState==='visible',active=foreground&&now-lastActivity<=30000;
    if(active)pageActive+=delta;
    for(const r of records){
      if(foreground&&r.el.isConnected!==false&&r.visible&&visibleStyle(r.el)){
        r.continuous+=delta;r.total+=delta;r.lastSeen=new Date().toISOString();
        if(active){r.active+=delta;r.lastActive=r.lastSeen;}
        if(!r.seen&&r.continuous>=1000){r.seen=true;emit(r.topic==='purchase_action'?'purchase_action_exposed':r.topic==='offer'?'offer_exposed':'policy_content_exposed',fieldsFor(r));}
      }else r.continuous=0;
    }
    const notice=document.querySelector('[data-product-cart-notice]:not([hidden]),[data-cart-drawer][open]');
    const success=notice&&(notice.matches('[data-cart-drawer]')||notice.dataset.state==='success');
    const a=currentAction;
    if(foreground&&success&&a?.done){
      const rect=notice.getBoundingClientRect(),visible=rect.width>0&&rect.height>0&&rect.top<innerHeight&&rect.bottom>0;
      const key=a.id+'|'+(notice.matches('[data-cart-drawer]')?'drawer':'notice');
      if(visible){if(noticeKey!==key){noticeKey=key;noticeStart=now;noticeVisible=false;}if(!noticeVisible&&now-noticeStart>=1000){noticeVisible=true;emit('cart_confirmation_exposed',{action_id:a.id,entry_location:notice.matches('[data-cart-drawer]')?'cart_drawer':'product_notice',outcome:a.outcome||'unknown',interaction_type:'success_message'});}}
    }else if(noticeVisible){emit('cart_confirmation_dismissed',{action_id:a?.id||null,interaction_type:'visibility_ended'});noticeVisible=false;noticeKey=null;}
  };
  ['pointerdown','keydown','scroll','touchstart'].forEach(n=>document.addEventListener(n,()=>{lastActivity=performance.now();lastActivityAt=new Date().toISOString();},{passive:true}));
  const checkoutIntent=(entry,kind)=>{const now=performance.now();if(now-lastCheckout<1000)return;lastCheckout=now;refreshContext();context.purchase_stage='checkout_intent';write(context);emit('checkout_clicked',{action_id:uuid(),entry_location:entry,target_path:'/checkouts',interaction_type:kind});};
  document.addEventListener('click',event=>{
    const el=event.target.closest('a,button');if(!el||!ready())return;
    const target=el.tagName==='A'?safePath(el.href):null;
    const entry=el.closest('[data-cart-drawer]')?'cart_drawer':el.closest('[data-product-cart-notice]')?'product_notice':el.closest('.product-info')?'product_summary':el.closest('footer')?'footer':'page';
    if(target==='/cart')emit('view_cart_clicked',{action_id:currentAction?.id||null,entry_location:entry,target_path:'/cart'});
    if(el.name==='checkout'||target==='/checkout'||target==='/checkouts'){
      checkoutIntent(entry,'click');
    }
    if(target&&policyFor(target)){emit('policy_navigation',{entry_location:entry,target_path:target,policy_id:policyFor(target),interaction_type:'enter_policy'});}
    if(policyFor(path)&&target&&/^\/(products|cart|collections)(\/|$)/.test(target))emit('policy_navigation',{policy_id:policyFor(path),target_path:target,interaction_type:'return_to_shopping',entry_location:entry});
  },true);
  document.addEventListener('submit',event=>{
    if(event.submitter?.name==='checkout'&&ready()){
      checkoutIntent(event.target.closest('[data-cart-drawer]')?'cart_drawer':'cart_page','form_submit');
    }
  },true);
  document.addEventListener('change',event=>{
    if(event.target.matches('[data-variant-select]')&&event.isTrusted){const p=productFields();if(p.availability===false)emit('variant_unavailable',{...p,error_category:'variant_unavailable'});}
    const el=event.target;
    if(el.matches('[data-insert-choice],[data-cart-insert-choice],[data-mystery-style]')&&event.isTrusted)emit('offer_selected',{product_id:null,display_price:numeric(el.dataset.mysteryPrice||el.closest('label')?.querySelector('b,[data-insert-price]')?.textContent),display_price_currency:window.Shopify?.currency?.active||null,offer_type:el.matches('[data-mystery-style]')?'mystery':'accessory',variant_id:el.value,offer_selected:el.checked,entry_location:el.closest('[data-cart-drawer]')?'cart_drawer':el.closest('.product-form')?'product_form':'cart_page'});
  },true);
  document.addEventListener('toggle',event=>{
    if(event.target.tagName==='DETAILS'&&event.target.open&&ready()&&policyFor(path))emit('policy_content_interacted',{policy_id:policyFor(path),policy_version:'p2-'+hash(textOf(document.querySelector('main'))),module_id:'details_'+hash(textOf(event.target.querySelector('summary'))),content_topic:'policy_details',interaction_type:'details_expanded'});
  },true);
  const leave = reason => {
    if(!started||!ready())return;flush(true);
    const seen=records.filter(r=>r.seen&&r.topic!=='purchase_action').sort((a,b)=>String(b.lastActive||b.lastSeen).localeCompare(String(a.lastActive||a.lastSeen)));
    const last=Date.parse(seen[0]?.lastActive||seen[0]?.lastSeen||'')||0;
    const candidates=seen.filter(r=>last-(Date.parse(r.lastActive||r.lastSeen)||0)<=500).slice(0,8);
    emit('page_exit_hint',{policy_id:policyFor(path),module_id:candidates.length===1?candidates[0].id:'page',content_topic:candidates.length>1?'multiple_candidates':candidates[0]?.topic||'unknown',interaction_type:reason,active_time_ms:Math.round(pageActive),last_content_candidates:candidates.map(r=>({module_id:r.id,content_topic:r.topic,seen_at:r.lastActive||r.lastSeen}))});
    for(const a of actions)result(a,'unknown',{error_category:'page_left_before_response'},false);
  };
  document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='hidden')leave('tab_hidden');else{lastTick=performance.now();noticeStart=performance.now();}});
  window.addEventListener('pagehide',()=>leave('pagehide'));
  if(typeof MutationObserver==='function'&&document.body){let pending=false;new MutationObserver(()=>{if(!pending){pending=true;setTimeout(()=>{pending=false;if(started)collectOffers();},300);}}).observe(document.body,{childList:true,subtree:true});}
  // Keep BFCache pages instrumented when revisited; do not permanently clear timers on pagehide.
  setInterval(tick,500);setInterval(()=>flush(false),15000);
})();

})();
